import React, { useEffect, useState } from "react"
import classNames from "classnames"
import Logo from "./logo"
import ChannelTile from "../channeltile"
import ShopButton from "../shopbutton"

import greenShop from "../../images/xhdpi_Shop.png"
import SearchBar from "../searchbar"
import styled from "@emotion/styled"

import { CHANNELS } from "../../utils/general"

import { queries } from "../../utils/mediaqueries"

import { connect } from "react-redux"

import { toggleLogoVisible } from "../../actions"

const HamburgerOpenCloseContainer = styled.div`
  position: relative;
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  float: right;
  @media (min-width: 768px) {
    display: none;
  }
`
const HamburgerOpenCloseIcon = styled.span`
  position: absolute;
  z-index: 10;
  width: 3rem;
  height: 1.8rem;
  cursor: pointer;
  span,
  span:before,
  span:after {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    text-indent: -9999px;
    background-color: #2d2d2d;
    height: 2px;
    width: 20px;
  }
  span {
    width: 20px;
    margin-left: 0.3rem;
    margin-top: 0.3rem;
  }
  span:before {
    top: 0.5rem;
  }
  span:after {
    top: 1rem;
  }
`

const HeaderWrap = styled.header`
  display: block;
  overflow: auto;
  background: rgb(248, 248, 245);
  &.nav-open {
    .wrap {
      position: relative;
    }
    &.second-level-active {
      .logo-wrap,
      .right-wrap {
        display: none;
      }
      .back-wrapper {
        display: inline-block;
      }
    }
  }
`
const HeaderContainer = styled.div`
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 20px;
  padding-bottom: 10px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
  background: rgb(248, 248, 245);
  &.no-left-pad {
    padding-left: 0;
    ${queries.medium`
      padding-left: 25px;
    `}
  }
  @media (min-width: 768px) {
    padding-top: 0;
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 0;
    position: relative;
  }
  @media (min-width: 768px) and (max-width: 778px) {
    padding-left: 20px;
    padding-right: 15px;
  }
`

const RightWrap = styled.div`
  display: inline-block;
  vertical-align: top;
  text-align: right;
  margin-right: 1.25rem;
  width: calc(100% - 75px);
  .search-icon {
    height: 30px;
  }
  @media (min-width: 768px) {
    float: right;
    width: auto;
    margin-right: 0;
    padding: 17px 8% 15px 0;
  }
`
const ContentsContainer = styled.div`
  @media (min-width: 768px) {
    font-size: 0;
  }
`

const SubContentsContainer = styled.div`
  display: none;
  ${queries.medium`
    display: flex;
  `}
  flex-direction: row;
  justify-content: space-between;
`

const SubContentsWrapper = styled.div`
  width: 100%;
  background: rgb(248, 248, 245);
  &.is-sticky {
    padding-left: 25px;
    padding-right: 25px;
  }
`

const SubContentsWrapperWrapper = styled.div`
  width: 100%;
  background: rgb(248, 248, 245);
  &.is-sticky {
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 100% !important;
    margin-left: auto;
    margin-right: auto;
    z-index: 100;
    left: 0;
    right: 0;
  }
`

const Header = (props) => {
  const { logoVisible, toggleLogoVisible, searchIndex } = props
  const [sticky, setSticky] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 87) {
      setSticky(true)
      props.setStickyHeader(true)
    } else {
      setSticky(false)
      props.setStickyHeader(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", () => handleScroll)
    }
  }, [])

  const renderChannels = () => {
    return CHANNELS.map((channel, idx) => (
      <React.Fragment key={`item-${idx}`}>
        <ChannelTile logoVisible={logoVisible} channel={channel} />
        {idx === CHANNELS.length - 1 && <ShopButton image={greenShop} />}
      </React.Fragment>
    ))
  }

  return (
    <HeaderWrap
      className={classNames("header-wrap", {
        "nav-open": props.navOpen,
      })}
    >
      <HeaderContainer
        className={
          logoVisible ? "container-no-pad" : "container-no-pad no-left-pad"
        }
      >
        <ContentsContainer className="wrap">
          <Logo logoVisible={logoVisible} />
          <HamburgerOpenCloseContainer className="burger-container">
            <HamburgerOpenCloseIcon
              className="toggle-nav"
              onClick={() => props.toggleMobileNav()}
            >
              <span>{`Toggle Navigation`}</span>
            </HamburgerOpenCloseIcon>
          </HamburgerOpenCloseContainer>
          <RightWrap className="right-wrap">
            <SearchBar
              toggleLogoVisible={toggleLogoVisible}
              searchIndex={searchIndex}
            />
          </RightWrap>
        </ContentsContainer>
        <SubContentsWrapperWrapper className={sticky ? "is-sticky" : ""}>
          <SubContentsWrapper
            id={`sub-contents-container`}
            className={sticky ? "is-sticky container-no-pad" : ""}
          >
            <SubContentsContainer className="wrap">
              {renderChannels()}
            </SubContentsContainer>
          </SubContentsWrapper>
        </SubContentsWrapperWrapper>
      </HeaderContainer>
    </HeaderWrap>
  )
}

const mapStateToProps = (state) => {
  return {
    expanded: state.searchBarExpandedReducer.expanded,
    logoVisible: state.logoVisibleReducer.logoVisible,
  }
}

export default connect(mapStateToProps, { toggleLogoVisible })(Header)
